export default __webpack_public_path__ + "static/media/z010mi0c.f1f3a185.mp3";